/**
 * InteractionModeBadge — aparece APENAS quando o mestre assumiu o controle.
 *
 * Em modo free (default), nada é exibido — o aluno está no estado padrão
 * e não precisa de indicador "exploração livre" cluttering a tela.
 * Quando mestre assume (master-led), badge vibrante avisa o aluno de que
 * a tela dele está sendo conduzida.
 *
 * Só renderiza pro role=player (master já tem o toggle próprio).
 * Posição: top-right.
 */

import { useAdapter } from '../adapter'
import { useSessionState } from '../hooks/useSessionState'

export function InteractionModeBadge() {
  const adapter = useAdapter()
  const { interactionMode } = useSessionState()

  if (adapter.role !== 'player') return null
  if (interactionMode !== 'master-led') return null

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 12,
        right: 12,
        zIndex: 40,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 12px',
        background: '#5B2DB8',
        border: '1px solid #5B2DB8',
        color: '#FFFFFF',
        borderRadius: 6,
        fontFamily: 'var(--font-lab-mono, monospace)',
        fontSize: '0.75rem',
        fontWeight: 700,
        letterSpacing: 0.3,
        boxShadow: '0 2px 6px rgba(15, 17, 21, 0.12)',
      }}
    >
      <span aria-hidden="true">🔒</span>
      <span>mestre conduzindo</span>
    </div>
  )
}
